module.exports = __webpack_public_path__ + "static/media/Sigtuna.0a2c3a80.png";